export const patientsRoot = "/patients";
export const groupsRoot = "/groups";
export const patientsRoutes = {
  patients: patientsRoot,
  groups: groupsRoot,
} as const;
